// Static sample data for the locked sneak-peek tabs. Same shapes as the
// insights / advanced / segment-customers responses (DASHBOARD_ANALYTICS_PLAN.md),
// so the real components render it unchanged. Never shown as real numbers:
// LockedPreview blurs it and labels it "Sample data". Names are invented.

const days = (n) => {
  const date = new Date();
  date.setDate(date.getDate() - n);
  return date.toISOString();
};

const heatmap = [];
const DAY_WEIGHT = [0.5, 0.75, 0.6, 0.7, 0.8, 0.95, 1.25];
const HOUR_WEIGHT = [0.3, 0.45, 0.55, 0.6, 0.5, 0.45, 0.5, 0.6, 0.8, 1.0, 0.95, 0.6];
for (let dow = 0; dow < 7; dow += 1) {
  for (let i = 0; i < 12; i += 1) {
    heatmap.push({
      dow,
      hour: 9 + i,
      visits: Math.round(DAY_WEIGHT[dow] * HOUR_WEIGHT[i] * 40),
    });
  }
}

export const sampleInsights = {
  range_days: 30,
  retention: {
    repeat_rate: { current: 0.54, previous: 0.51 },
    median_days_between_visits: { current: 11.4, previous: 12.2 },
    redemption_rate: { current: 0.31, previous: 0.29 },
    at_risk: { current: 128, previous: 114 },
  },
  health: { active: 1840, cooling: 620, at_risk: 128, lost: 824, never: 310 },
  funnel: { signed_up: 1240, first_visit: 1010, three_plus_visits: 618, first_reward: 286 },
  top_rewards: [
    { campaign_id: 1, name: "Free coffee", count: 142 },
    { campaign_id: 2, name: "Half-price pastry", count: 88 },
    { campaign_id: 3, name: "Free tote bag", count: 41 },
    { campaign_id: 4, name: "Kids' treat", count: 19 },
  ],
  staff: [
    { user_id: 1, name: "Alex", scans: 612, rewards: 74 },
    { user_id: 2, name: "Sam", scans: 488, rewards: 51 },
    { user_id: 3, name: "Robin", scans: 205, rewards: 22 },
  ],
  cards: [
    { pass_id: 1, name: "Stamp card", customers: 2410, visit_share: 0.71 },
    { pass_id: 2, name: "VIP card", customers: 1002, visit_share: 0.29 },
  ],
  heatmap,
  upcoming: {
    birthdays_7d: {
      count: 23,
      customers: [
        { id: 1, name: "Maria Lopez", birthday: "10-23" },
        { id: 2, name: "Jonas Berg", birthday: "10-25" },
        { id: 3, name: "Lena Novak", birthday: "10-27" },
      ],
    },
    expiring_30d: { points: 1960, customers: 86 },
  },
};

const sampleRows = [
  ["Hannah Vogel", 63, 12, 90],
  ["Emre Yilmaz", 67, 7, 60],
  ["Chloe Laurent", 71, 5, 40],
  ["Matteo Ricci", 78, 15, 80],
  ["Selin Kaya", 86, 3, 30],
];

export const sampleSegmentCustomers = {
  total_count: 128,
  page: 1,
  per_page: 50,
  customers: sampleRows.map(([name, ago, visits, balance], index) => ({
    id: index + 1,
    name,
    last_visit_at: days(ago),
    visits,
    balance,
  })),
};

export const sampleAdvanced = {
  cohorts: [
    { month: "2026-05", customers: 212, retention: [1, 0.41, 0.33, 0.29, 0.26, 0.24] },
    { month: "2026-06", customers: 248, retention: [1, 0.39, 0.31, 0.27, 0.25] },
    { month: "2026-07", customers: 301, retention: [1, 0.37, 0.3, 0.26] },
    { month: "2026-08", customers: 276, retention: [1, 0.42, 0.34] },
    { month: "2026-09", customers: 334, retention: [1, 0.45] },
    { month: "2026-10", customers: 198, retention: [1] },
  ],
  points_by_channel: [
    { channel: "scan", points: 13140, share: 0.78 },
    { channel: "shopify", points: 1520, share: 0.09 },
    { channel: "initial", points: 1180, share: 0.07 },
    { channel: "birthday", points: 670, share: 0.04 },
    { channel: "referrer", points: 330, share: 0.02 },
  ],
  message_impact: {
    baseline_rate: 0.18,
    messages: [
      { id: 1, message: "We miss you! Double points this week.", segment: "at_risk", sent_at: days(9), delivered: 412, visited_7d: 136, rate: 0.33 },
      { id: 2, message: "Happy birthday from us", segment: null, sent_at: days(12), delivered: 188, visited_7d: 71, rate: 0.38 },
      { id: 3, message: "Double points Tuesday", segment: null, sent_at: days(16), delivered: 2310, visited_7d: 531, rate: 0.23 },
      { id: 4, message: "New VIP rewards are here", segment: null, sent_at: days(28), delivered: 2290, visited_7d: 389, rate: 0.17 },
    ],
  },
};
